<template>
  <div class="health-push-dialog" v-if="visible">
    <div class="dialog-overlay" @click="closeDialog"></div>
    <div class="dialog-content">
     
      <div class="dialog-body">
        <!-- 顶部logo图片 -->
        <div class="logo-container">
          <img src="@/assets/push/push-fei-logo.png" alt="肺健康" class="logo-img" />
        </div>

        <!-- 标题 -->
        <div class="title-container">
          <img src="@/assets/push/push-fei-title.png" alt="肺部健康守护计划" class="title-img" />
        </div>

        <!-- 按钮组 -->
        <div class="btn-group">
          <div class="action-btn primary" @click="viewDetails">查看详情</div>
          <!-- <div class="action-btn secondary" @click="closeDialog">关闭</div> -->
        </div>
      </div>
      <!-- 关闭按钮 -->
      <!-- <div class="close-btn" @click="closeDialog">
        <img src="@/assets/push/push-fei-close.png" alt="关闭" />
      </div> -->
    <div style="height: 50px;text-align: center;padding-top: 30px;">
      <img class="close-btn" src="@/assets/push/push-fei-close.png" @click="closeDialog" alt="关闭" />
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthPushDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailUrl: {
      type: String,
      default: 'https://video.pacsonline.cn/value/20251216.jpg'
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    viewDetails() {
      // 打开图片详情弹窗
      this.$emit('view-details');
    }
  }
};
</script>

<style scoped>
.health-push-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.dialog-content {
  position: relative;
  width: 85%;
  max-width: 350px;
  /* background: #fff; */
  border-radius: 16px;
  overflow: hidden;
  z-index: 1;
}

.close-btn {
  /* position: absolute;
  bottom: 20px;
  right: 20px; */
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 2;
}

.close-btn img {
  width: 100%;
  height: 100%;
}

.dialog-body {
  padding: 0;
  text-align: center;
}

.logo-container {
  width: 100%;
  background: linear-gradient(to bottom, #a8d8f0, #ffffff);
  /* padding: 20px 0 10px; */
}

.logo-img {
  width: 100%;
  /* max-width: 280px; */
  height: auto;
}

.title-container {
  padding: 20px 20px 30px;
  background: #fff;
}

.title-img {
  width: 80%;
  max-width: 220px;
  height: auto;
}

.btn-group {
  padding: 0 20px 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.action-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 22px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
}

.action-btn.primary {
  background: #3B9FCC;
  color: #fff;
}

.action-btn.secondary {
  background: #f5f5f5;
  color: #666;
}

.action-btn:active {
  opacity: 0.8;
  transform: scale(0.98);
}
</style>
